export enum PRODUCT_CARD_VARIANTS {
    CONTAINED,
    FLOATING,
}
